import { useState } from 'react';

import styled from 'styled-components';
import ForgotPassword from './forgot-password';
import Login from './login';
import { PasswordReset } from './password-reset';
import Register from './register';

export enum LoginRegisterMode {
    LOGIN = 'Login',
    REGISTER = 'Register',
    REGISTER_SUCCESS = 'RegisterSuccess',
    FORGOT_PASSWORD = 'ForgotPassword',
    PASSWORD_RESET = 'PasswordReset',
}

interface LoginRegisterDialogProps {
    initialMode?: LoginRegisterMode;
    onRegisterSuccess?: () => void;
    onLoginSuccess?: () => void;
}

const LoginRegister = (props: LoginRegisterDialogProps) => {
    const [mode, setMode] = useState<LoginRegisterMode>(props.initialMode || LoginRegisterMode.LOGIN);
    const [email, setEmail] = useState<string>('');

    const handleClickLogin = () => {
        setMode(LoginRegisterMode.LOGIN);
    };

    const handleClickRegister = () => {
        setMode(LoginRegisterMode.REGISTER);
    };

    const handleClickForgotPassword = () => {
        setMode(LoginRegisterMode.FORGOT_PASSWORD);
    };

    const handleChangeMode = (newMode: LoginRegisterMode) => {
        setMode(newMode);
    };

    return (
        <Page>
            <Logo src="/assets/soar_logo_large.png" alt="Soar Logo" />
            <LoginContainer>
                {mode === LoginRegisterMode.LOGIN ? (
                    <Login
                        email={email}
                        onEmailChange={setEmail}
                        onClose={() => null}
                        handleClickForgotPassword={() => handleClickForgotPassword()}
                        handleClickRegister={() => handleClickRegister()}
                        onLoginSuccess={() => {
                            if (props.onLoginSuccess) {
                                props.onLoginSuccess();
                            }
                        }}
                    />
                ) : null}
                {mode === LoginRegisterMode.REGISTER ? (
                    <Register
                        email={email}
                        onEmailChange={setEmail}
                        onClose={() => null}
                        handleClickLogin={() => handleClickLogin()}
                        onRegisterSuccess={() => {
                            if (props.onRegisterSuccess) {
                                props.onRegisterSuccess();
                            } else {
                                setMode(LoginRegisterMode.REGISTER_SUCCESS);
                            }
                        }}
                    />
                ) : null}
                {mode === LoginRegisterMode.FORGOT_PASSWORD ? (
                    <ForgotPassword
                        email={email}
                        onEmailChange={setEmail}
                        onClose={() => null}
                        handleClickLogin={() => handleClickLogin()}
                    />
                ) : null}
                {mode === LoginRegisterMode.PASSWORD_RESET ? (
                    <PasswordReset onClose={() => handleChangeMode(LoginRegisterMode.LOGIN)} />
                ) : null}
            </LoginContainer>
        </Page>
    );
};

export default LoginRegister;

const Page = styled.div`
    min-width: 100vw;
    min-height: 100vh;
    background: ${(props) => props.theme.color.background};
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const Logo = styled.img`
    width: 350px;
    height: 155px;
`;

const LoginContainer = styled.div`
    width: 400px;
    height: 100%;
    border: 1px solid rgb(255 255 255 / 0.3);
    background-color: transparent;
    border-radius: 6px;
    margin-bottom: 20px;
    padding: 8px;

    div.modal-content {
        background-color: transparent !important;
        margin: 0 auto;
    }

    @media (max-width: 650px) {
        width: 100% !important;
        margin-top: 50px; // this is set but possibly needs to be percent for mobile?
    }
`;
